import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `简洁清晰的重现步骤能够帮助我们更迅速地定位问题所在。支持使用 `, /*#__PURE__*/React.createElement("a", {
    href: "https://guides.github.com/features/mastering-markdown/",
    target: "_blank"
  }, `Markdown`), ` 来格式化列表或是代码片段。`));
};